import { FormInputTypes } from '@components/_old/dynamicForm';
import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
  IEnhancedTableMenuItem,
} from '@components/table/widgets/shared-with-old';
import { IListingFilterWidgetSection } from '@components/widgets/listing-filter-widget';
import { IAbstractRecord } from '@models';
import { enumListAsRecordObject } from '@utils/graph-utils';

export const headers: Record<string, EnhancedTableHeader> = {
  insurance_NSSFCodeRange_RangeFrom: {
    name: 'insurance_NSSFCodeRange_RangeFrom',
    title: 'Code Number From',
    type: EnhancedTableHeaderType.Text,
  },
  insurance_NSSFCodeRange_RangeTo: {
    name: 'insurance_NSSFCodeRange_RangeTo',
    title: 'Code Number To',
    type: EnhancedTableHeaderType.Text,
  },
  insurance_NSSFCodeRange_NSSFCodeReached: {
    name: 'insurance_NSSFCodeRange_NSSFCodeReached',
    title: 'Code Number Reached',
    type: EnhancedTableHeaderType.Text,
  },
  insurance_NSSFCodeRange_RangeStatus: {
    name: 'insurance_NSSFCodeRange_RangeStatus',
    title: 'Status',
    type: EnhancedTableHeaderType.Text,
  },
  insurance_NSSFCodeRange_createdOn: {
    name: 'insurance_NSSFCodeRange_createdOn',
    title: 'Created on',
    type: EnhancedTableHeaderType.Date,
  },
  insurance_NSSFCodeRange_modifiedOn: {
    name: 'insurance_NSSFCodeRange_modifiedOn',
    title: 'Modified on',
    type: EnhancedTableHeaderType.Date,
  },
};

export function filterSectionsContent(
  data: any,
  filterValues: IAbstractRecord
): IListingFilterWidgetSection[] {
  const newFilterSections: IListingFilterWidgetSection[] = [
    {
      title: 'Filters',
      inputs: {
        status: {
          name: 'status',
          title: 'Status',
          type: FormInputTypes.chips,
          value: filterValues?.status || [],
          placeholder: 'Status',
          triggerUpdate: true,
          selectOptions: enumListAsRecordObject(
            data?.Insurance_RangeStatuses?.enumValues
          ),
        },
      },
    },
  ];
  return newFilterSections;
}

export const actions: IEnhancedTableMenuItem[] = [
  {
    title: '+ New',
    onClick: () => undefined,
    isEntity: false,
    isBulk: false,
    iconUrl: '',
  },
];
